'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MediaHeading = require('react-bootstrap/lib/MediaHeading');

var _MediaHeading2 = _interopRequireDefault(_MediaHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MediaHeading2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/MediaHeading.js
// module id = 634
// module chunks = 0